// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagKitIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M16.46 4.4h2.03c2.21 0 4 1.8 4 4v3.29q-.01.47-.4.7c-3 1.66-6.38 2.53-9.8 2.53h-.62c-3.38 0-6.76-.87-9.75-2.53-.26-.14-.42-.4-.42-.7V8.4c0-2.2 1.8-4 4-4h2.04c.14-1.59 1.48-2.83 3.1-2.83h2.71c1.62 0 2.96 1.24 3.11 2.83m-1.63 0c-.14-.7-.75-1.22-1.48-1.22h-2.7c-.74 0-1.35.52-1.48 1.22z"
      />
      <path
        d="M18.08 22.43H5.92c-2.19 0-4.03-1.7-4.2-3.89l-.2-3.63c-.03-.6.6-.73 1.14-.5q4.13 1.82 8.22 2.05c.17 0 .31.15.31.32v1.3c0 .45.36.8.8.8s.82-.35.82-.8v-1.29c0-.17.13-.31.3-.32q4.17-.2 8.22-2.05c.54-.24 1.18-.1 1.14.5l-.2 3.6c-.16 2.2-2 3.91-4.2 3.91"
        opacity=".5"
      />
    </g>
  </SvgIcon>
);

export default TagKitIcon;
